import { Tag } from "@fanduel/formation-react-components";
import Image from "@/components/Image";
import { TableDataT } from "./usePassingTable";
import styles from "./gameLeaders.module.scss";

type PlayerCellProps = Pick<
  TableDataT["passing_leader"],
  "abbreviation" | "logoSVG" | "name" | "position"
>;

export default function PlayerCell({
  abbreviation,
  logoSVG,
  name,
  position,
}: PlayerCellProps) {
  return (
    <div className={styles.cell}>
      <Image
        width={40}
        height={40}
        src={logoSVG ?? ""}
        alt={abbreviation ?? ""}
      />

      <div className={styles.nameLine}>
        <Tag className={styles.playerTag}>{position}</Tag>
        <span className={styles.playerName}>{name}</span>
      </div>
    </div>
  );
}
